import React from 'react';
import NaaSPdf from './NaaS_Cloud_whitepaper.pdf';
import MDUPdf from './MDU_NaaS_whitepaper.pdf';
import HospitalityPdf from './Hospitality_cloud_whitepaper.pdf';
import EducationPdf from './Education_cloud_whitepaper.pdf';
import WarehousePdf from './Warehouse_cloud_whitepaper.pdf';

const papers = [
  {
    title: 'NaaS Cloud Platform Architecture',
    desc: 'A comprehensive overview of the Sarvanta NaaS Cloud platform — architecture, deployment models, multi-tenant management, and how cloud-native networking reduces operational costs.',
    pdf: NaaSPdf
  },
  {
    title: 'MDU NaaS Deployment Guide',
    desc: 'How to deploy managed WiFi in multi-dwelling units. Covers network design, revenue models, tenant onboarding, and AI-based radio management for high-density residential environments.',
    pdf: MDUPdf
  },
  {
    title: 'Hospitality Cloud WiFi',
    desc: 'Designing guest WiFi experiences that drive satisfaction and revenue. Covers Personal Area Networks, captive portals, bandwidth management, and multi-property cloud management.',
    pdf: HospitalityPdf
  },
  {
    title: 'Education Network Considerations',
    desc: 'Key considerations for upgrading school and campus networks. Covers CIPA compliance, content filtering, device management, network segmentation, and scalable deployment strategies.',
    pdf: EducationPdf
  },
  {
    title: 'Warehouse WiFi Solutions',
    desc: 'Implementing reliable WiFi in warehouse and industrial environments. Covers RF challenges, access point placement, IoT device support, and maintaining coverage in dynamic inventory conditions.',
    pdf: WarehousePdf
  }
];

const Whitepapers = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>White Papers</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          In-depth technical papers covering our platform architecture and industry-specific
          deployment guides. Download and share with your team.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {papers.map((paper, i) => (
            <div key={i} style={{
              padding: '28px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744', display: 'flex', justifyContent: 'space-between',
              alignItems: 'flex-start', gap: '24px', flexWrap: 'wrap'
            }}>
              <div style={{ flex: 1, minWidth: '250px' }}>
                <h2 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#60a5fa' }}>{paper.title}</h2>
                <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{paper.desc}</p>
              </div>
              <a href={paper.pdf} target="_blank" rel="noopener noreferrer" style={{
                padding: '10px 24px', backgroundColor: '#2563eb', color: '#fff',
                borderRadius: '8px', textDecoration: 'none', fontWeight: '600',
                whiteSpace: 'nowrap', flexShrink: 0
              }}>Download PDF</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Whitepapers;
